import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FONT_TYPES } from '../../constants';
import { TextMixin } from '../../mixins/components/TextMixin';
import CustomPropTypes from '../../util/custom-prop-types';

/**
 * By default it will create a `<span>` with body type ramp.
 *
 * @related ['Heading', 'Paragraph']
 * @since 6.0.0
 */

var Text = /*#__PURE__*/styled.span.withConfig({
  displayName: "Text",
  componentId: "c11n-8-111-1__sc-aiai24-0"
})(["", ""], TextMixin);
Text.displayName = 'Text';
Text.propTypes = {
  /**
   * A color token,
   * e.g. `'textDark'`, `'textWhite'`.
   * Set this to an empty string to remove color styles.
   */
  fontColor: PropTypes.string,
  /**
   * The font type of the text determines the size, weight, and line-height.
   *
   * Supports inline media query objects
   */
  fontType: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(Object.values(FONT_TYPES))),
  /**
   * Change the text alignment of the text.
   *
   * Supports inline media query objects.
   */
  textAlign: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['left', 'center', 'right'])),
  /**
   * Change the text wrapping of the text.
   *
   * Note: This feature is a part of [CSS Text Level 4](https://www.w3.org/TR/css-text-4/#text-wrap)
   * and not yet supported across all browsers.
   *
   * Supports inline media query objects.
   */
  textWrap: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['wrap', 'nowrap', 'balance', 'stable', 'pretty'])),
  /**
   * The styled-components
   * [polymorphic "as"](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
};
Text.defaultProps = {
  fontColor: 'textDark',
  fontType: FONT_TYPES.body
};

/** @component */
export { Text };